import {useTheme} from '@mui/material';

interface QuantityPickerIconsProps {
  width?: string;
  height?: string;
  fillBg?: string;
  fillRect?: string;
  disabled?: boolean;
}

export const PlusIconWithBg = ({
  width = '32',
  height = '32',
  fillBg = '#FFFFFF',
  fillRect = '#F22643',
  disabled = false
}: QuantityPickerIconsProps) => {
  const theme = useTheme();

  const _fillBg = !disabled ? fillBg : theme.palette.grey[400];
  const _fillRect = !disabled ? fillRect : theme.palette.grey[200];
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={width} height={height} rx="16" fill={_fillRect} />
      <g clip-path="url(#clip0_12567_33815)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.4192 16.0001C25.4192 16.2691 25.3123 16.527 25.1221 16.7172C24.9319 16.9074 24.674 17.0142 24.405 17.0142H17.0137V24.4055C17.0137 24.6745 16.9069 24.9324 16.7167 25.1226C16.5265 25.3128 16.2686 25.4196 15.9996 25.4196C15.7307 25.4196 15.4727 25.3128 15.2825 25.1226C15.0923 24.9324 14.9855 24.6745 14.9855 24.4055V17.0142H7.59421C7.32524 17.0142 7.0673 16.9074 6.87711 16.7172C6.68692 16.527 6.58008 16.2691 6.58008 16.0001C6.58008 15.7311 6.68692 15.4732 6.87711 15.283C7.0673 15.0928 7.32524 14.986 7.59421 14.986H14.9855V7.59469C14.9855 7.32573 15.0923 7.06778 15.2825 6.8776C15.4727 6.68741 15.7307 6.58057 15.9996 6.58057C16.2686 6.58057 16.5265 6.68741 16.7167 6.8776C16.9069 7.06778 17.0137 7.32573 17.0137 7.59469V14.986H24.405C24.674 14.986 24.9319 15.0928 25.1221 15.283C25.3123 15.4732 25.4192 15.7311 25.4192 16.0001Z"
          fill={_fillBg}
        />
      </g>
      <defs>
        <clipPath id="clip0_12567_33815">
          <rect width="20" height="20" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  );
};
